import * as React from 'react';

import {Card} from '../card/card';
import type {ColorName} from '../colors/colors';
import {StackLegacy} from '../layout/stack/stack-legacy';
import type {StackSpacing} from '../layout/stack/stack-legacy';

type Props = {
    barHeight?: number;
    spacing?: StackSpacing;
    numBars?: number;
    padding?: number;
    backgroundColor?: ColorName;
};

export function ListViewLoadingBars(props: Props) {
    const {
        barHeight = 70,
        spacing = 16,
        numBars = 4,
        padding = 16,
        backgroundColor = 'offWhiteDk',
    } = props;

    return (
        <div style={{padding}}>
            <StackLegacy spacing={spacing}>
                {[...Array(numBars)].map((_, index) => (
                    <Card
                        key={`placeholder-${index}`}
                        fitHeight={true}
                        backgroundColor={backgroundColor}
                        hasBorder={false}
                    >
                        <div style={{height: barHeight}} />
                    </Card>
                ))}
            </StackLegacy>
        </div>
    );
}
